import * as React from 'react';
import icon from '../../assets/img/flags/colorado.svg';

export const Colorado = (props) => <img src={icon} height={props.height || 100} alt="Flag" />;
